import React, { useEffect, useRef, useState } from "react";
import ReminderOption from "../../Components/FormBuilder/Builder/FormInputs/Reminder/ReminderComponent/ReminderOption";
import Modal from "../../Components/UI/Modal";
import { callGET } from '../../Utils/ApiUtil';
import BootstrapRow from "../../hoc/BootstrapRow";
import ShowNotification from "../../Components/FormBuilder/Builder/FormInputs/Reminder/ReminderComponent/ReminderOption/ShowNotification";
import BootstrapColumn from '../../hoc/BootstrapColumn';
import { isValidEmail } from "../../Utils/UserFunctions";
import {isSet} from '../../Utils/CommonFunctions';



const KeyCodes = {
    comma: 188,
    enter: 13,
};
const delimiters = Object.values(KeyCodes);
const REMINDER_TYPES ={
    0: "Email",
    1: "Popup",
    2: "Email and Popup"
}
const BackgroundActionInputModal =(props)=>{
  
    const [state, setState] = useState({
        getAllUserList : [],
        suggestions : [],
    })

    const [reminderJson, setReminderJson] = useState({
        remind_alert : 2,
        toUserEmailIds: [],
    });

    const[inputField, setInputField] = useState({
        toEmail: '',
        error: '',
    });

    const onChangeHandler =(e)=>{
        const {name, value}= e.target;
        setInputField({
            [name]: value
        });
    }

    const searchUserHander = (event) => {
        const { name, value, options, selectedIndex } = event.target;  
        setInputField({
            [name]: value
        });
        let getSuggestions = [];
        getSuggestions = state.getAllUserList.filter(function(v,i) {
            if(v.email_address.toLowerCase().indexOf(value) >=0 || v.field_display_name.toLowerCase().indexOf(value) >=0) {
                return true;
            }else{
            	return false;
            }
        });
        setState((prev)=>({
            ...prev,
            suggestions: getSuggestions
        }))
    }

    const mailInputRef = useRef(null);

    const getUserListHandler = () => {
        let windowId = props.params?.windowId ?? '';

        if(windowId!==''){
            const API_Url = 'email/message/'+windowId+'/email-addresses?searchText=&metatableId=';
            callGET(API_Url)
            .then(res => {
                if(res.status===200){ 
                    const response = res.data;
                    if(response.code===200){
                        const responseData = response.data;
                        let getAllUserList = isSet(responseData.email_message,[]);
                        //console.log('getUserListHandler responseData===',responseData)
                        let updateSugestion = [];
                        if(getAllUserList.length>0){
                            getAllUserList.map((item,n)=>{
                                updateSugestion.push({
                                    metatable_id:item.metatable_id,
                                    field_display_name:item.field_display_name,
                                    index:n,
                                    email_field_display_name:item.email_field_display_name,
                                    email_address:item.email_address,                            
                                })
                            })
                        }	                    
                        setState({getAllUserList:getAllUserList,suggestions:[]})
                    }else{
                        setState({getAllUserList:[],suggestions:[]})
                    }
                }
            })
            .catch(err => {
                console.log(err);
            })	
        }    	
    }

    useEffect(()=>{
        getUserListHandler()
    }, [])

    const actionChangeHandler = (e, name, value)=>{
        setReminderJson({
            ...reminderJson, 
            [name]: value
        });
        setInputField({
            error: '',
        });
    }
    const handleDelete = (i) => {
        const { toUserEmailIds } = reminderJson;
        let removeUser = toUserEmailIds.filter((user, index) =>{
            if(index !== i){
                return user;
            }
        });
        
        setReminderJson({
            ...reminderJson,
          toUserEmailIds: removeUser,
        });
    }

  const handleOnBlur = () =>{
        setTimeout(()=>{
            setState({...state, suggestions:[]})
        },200)
    }

  const handleKeyDown = (event) => {        
        if (delimiters.indexOf(event.keyCode) !== -1 ) {
            const updateState = { ...inputField };
            
            let toEmail = updateState.toEmail || ' '; 
            if(toEmail.trim()!==''){
            	if(isValidEmail(toEmail)){
                    setReminderJson((state) => ({ ...state, toUserEmailIds: [...state.toUserEmailIds, toEmail]}));
                    setInputField({...inputField, toEmail : ''})
	            }else{
                    onChangeHandler({target :{name: 'error', value: "Invalid email address"}});
                }
           
            }            
        }
    }
    const excuteHandler =()=>{
        const {remind_alert, toUserEmailIds} = reminderJson;
        if((remind_alert == 0 || remind_alert == 2) && toUserEmailIds.length ==0){
            onChangeHandler({target :{name: 'error', value: "Email address cannot be empty"}});
            return false;
        }
        props.modelHandler({}, {}, { toUserEmailIds: reminderJson.toUserEmailIds.join(","), reminderAlert: reminderJson.remind_alert})
    }
    const reminderBtnList = [{
        attributes:{
          className:"btn btn-cancel mr-1",
          "data-dismiss":"modal",
          "id":"reminderCancel",
        },
        clickHandler:()=>props.modelHandler(),
        name:"Cancel"
      },
      {
        attributes:{
            className:"btn primary_bg",
        },
        disabled:false,
        name:"Execute",
        clickHandler: ()=> excuteHandler()
      }];
  
      let toUsers = '';
      toUsers = reminderJson.toUserEmailIds.map((users,index) => {
          let toTagCss = 'tag-wrapper ReactTags__tag';
          return(<span className={toTagCss} style={{"opacity": "1", "cursor": "move"}} draggable="false">{users}<a className="ReactTags__remove" onClick={e=>handleDelete(index)}>×</a></span>)
      })

      const addToUsers = (email)=>{
        setReminderJson((prev)=>({
            ...prev, 
            toUserEmailIds:[...prev.toUserEmailIds, email]
        }))
        setInputField({...inputField, toEmail : ''})
      }

    return(
        <Modal 
        isModalOpen={true}
        title={'Please select one of the action below to trigger and intimate the backgound process.'}
        modalDim={'height-auto modal-lg'}
        buttonList ={reminderBtnList}
        titleClass = 'text-default mb-1'
        zIndex={props.zIndex || '1050'}
        >
       
       <>
          <BootstrapRow>
            <BootstrapColumn column={`col-12`}>
            <ShowNotification 
               actionChangeHandler = {actionChangeHandler}            
               reminderJson={reminderJson} 
               isPopupNeeded = {false}
             />
             {
                (reminderJson.remind_alert == 0 || reminderJson.remind_alert == 2) && (
                    <div className="form-group row">
                <label htmlFor="to" className="col-md-2">To Email Address <span className="text-danger">*</span> </label>
                <div className="col-md-10">
                    <div className="d-inline-flex w-100">
                        <span className="px-2"> : </span>
                        <div className="ReactTags__tags react-tags-wrapper" style={{"paddingRight":"60px"}}>
                            <div className="ReactTags__selected">
                                {toUsers}										
                                <div className="ReactTags__tagInput">
                                    
                                    <input 
                                    className="ReactTags__tagInputField width_98_per w-100" 
                                    ref={mailInputRef}
                                    type="text" 
                                    name="toEmail"
                                    placeholder="Enter Email Address" 
                                    aria-label="Enter Email Address"											
									onBlur={()=>handleOnBlur()}										
                                    onChange={e=> searchUserHander(e)}
                                    onKeyDown={e => handleKeyDown(e)}
									onClick={e=>{ searchUserHander(e)}}
                                    value={inputField.toEmail}
                                    />

                                    {state.suggestions.length > 0 ?
                                        <div className="ReactTags__suggestions"><ul>
                                             {state.suggestions.map((user, index) => (
                                                    <li key={index} onClick={()=>addToUsers(user.email_address)}>
                                                        {user.email_address}
                                                    </li>
                                                ))}
                                            </ul></div>	
                                        : 
                                        ''
                                    }
                                                            
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-start" style={{gap:'5px', marginTop:'10px', paddingLeft:'15px'}}> 
                        <div className="">
                            <span> 
                                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" fill="#FFAC05FF"><path d="M0 0h24v24H0z" fill="none"></path><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"></path></svg>
                            </span>
                        </div>
                        <p className="m-0 text-muted"> <span style={{fontSize:'0.9rem', fontWeight:'bold'}}> "Type" </span>  or <span style={{fontSize:'0.9rem', fontWeight:'bold'}}> "Copy Paste" </span> the Email Address and Press Enter Key to Proceed. </p>
                    </div>
                    {inputField.error !== "" ? 
                    <label className="error m-0">{inputField.error}</label>
                    : null
                    } 
                </div>
            </div>
                )
             }
             <p className="text-danger mb-1 mt-5"> {`After execution done, The background process completion will notify you by reminder via [${REMINDER_TYPES[reminderJson.remind_alert]}]`} </p>
             
            </BootstrapColumn>
            </BootstrapRow>
            </>
        </Modal>
    )
}

export default BackgroundActionInputModal;